import { Box } from "@mui/material";

export const DropOverlay = () => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      zIndex: 2000,
      backgroundColor: "rgba(0,0,0,0.6)",
      border: "2px dashed var(--fx-surface-base, #FFFFFF)",
      color: "#fff",
      fontSize: 20,
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    Drop files here to upload
  </Box>
);
